// extracted by mini-css-extract-plugin
export default {"btn":"Cover_btn__nfqz0","title":"Cover_title__R2sDX","text":"Cover_text__6chzY","wrap":"Cover_wrap__HtT-e"};